// btw-front/src/components/partner/DealStageBadge.jsx
// 딜 상태 배지 — **심사가 끝나지 않은 딜은 영업단계 대신 심사 상태를 보여준다.**
//
// 심사와 영업단계는 별개 축이다(constants/dealReview.js). 둘을 한 배지에 섞으면
// "심사 중인데 영업단계가 제안" 처럼 읽혀 파트너가 딜이 이미 인정된 것으로 오해한다.
// 승인 전에는 영업단계를 감추고 '심사 중입니다' / '반려됨' 만 보여주는 것이 이 컴포넌트의 목적.
//
// 목록·카드·상세가 같은 규칙을 쓰도록 한 곳에 모았다 — 화면마다 따로 분기하면 어긋난다.
import React from "react";
import { useTranslation } from "react-i18next";
import { Badge } from "../ui/Badge";
import { showsReviewBadge, effectiveStatus } from "../../constants/dealReview";

export function DealStageBadge({ deal, className = "" }) {
  const { t } = useTranslation();
  if (!deal) return null;
  // 심사 전(심사 중·반려)이면 심사 배지만. tone 은 심사 상태값을 그대로 쓴다
  // (ui/Badge 에 pending=amber / rejected=rose 가 이미 있다).
  //
  // 표시할 값은 effectiveStatus 로 고른다 — 대시보드 상태 필터가 같은 함수를 쓴다.
  // 라벨 키만 축에 따라 갈린다(심사 상태는 review.*, 영업단계는 status.*).
  const value = effectiveStatus(deal);
  const labelKey = showsReviewBadge(deal)
    ? `partners.deals.review.${value}`
    : `partners.deals.status.${value}`;
  return (
    <Badge tone={value} className={className}>
      {t(labelKey)}
    </Badge>
  );
}
